<div
  class="tile-header"
  *ngIf="category.includes('headed')"
>
  <mable-heading
    [heading]="headingType"
    [color]="bannerHeadingColor"
    [icon]="icon"
    [iconColor]="iconColor"
    [class.text-center]="category.includes('tip')"
    [headingStyle]="headingStyle"
    >{{ heading }}</mable-heading
  >
  <ng-container *ngIf="category.includes('banner') && canClose">
    <ng-container *ngTemplateOutlet="crossButton"></ng-container>
  </ng-container>
</div>

<div class="tile-content">
  <div class="tile-content-body">
    <ng-content select=".content"></ng-content>
  </div>
  <ng-container *ngIf="category.includes('banner') && !category.includes('headed')">
    <ng-container *ngTemplateOutlet="crossButton"></ng-container>
  </ng-container>
</div>
<div class="tile-controls">
  <ng-content select=".controls"></ng-content>
</div>

<ng-template #crossButton>
  <mable-button
    [bannerId]="bannerId"
    category="icon-only"
    [ariaLabel]="'close'"
    color="grey-500"
    icon="close"
    size="small"
    (click)="onClose($event)"
    (onVisibilityToggle)="toggleTile($event)"
    mableSessionDismissibleButton
  >
  </mable-button>
</ng-template>
